var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortByAlpha = function SvgSortByAlpha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e8eaed",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m80-280 150-400h86l150 400h-82l-34-96H196l-32 96zm140-164h104l-48-150h-6zm328 164v-76l202-252H556v-72h282v76L638-352h202v72zM360-760l120-120 120 120zM480-80 360-200h240z"
  })));
};
export default SvgSortByAlpha;